import { FC } from 'react';
import { PageTitle, PageLink } from '../../../../rbts/layout/core';
import { Vista } from './components/Vistas';

const CortesiasReporte: FC = () => {
  const widgetsBreadCrumbs: Array<PageLink> = [
    {
      title: 'Reportes',
      path: '/reportes/cortesias',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <>
      <PageTitle breadcrumbs={widgetsBreadCrumbs}>{`${'Cortesías'}`}</PageTitle>
      <Vista />
    </>
  );
};

export { CortesiasReporte };
